<template>
  <div :class="[prefixCls]" ref="componentRoot">
      <div class="clip-form">
        <p class="static-text-one">编辑头像</p>
        <p class="static-text-two">调整头像尺寸和位置</p>
        <div class="close" @click="goBack">
          <img src="../assets/icon-clolse.png" width="100%" height="100%">
        </div>
        <croppa v-model="myCroppa" :width="322" :height="322"
        placeholder="请选择一张图片" :placeholder-font-size="15" :show-remove-button="false"
        :placeholder-color="'#bbbbbb'" :zoom-speed="8" @new-image-drawn="onNewImage" @zoom="onZoom"
        :disable-scroll-to-zoom="true">
        </croppa>
        <div class="range-handle">
           <div class="img-wrap" @click="shrink">
            <img src="../assets/icon-shrink.png" width="100%" height="100%">
          </div>
          <input type="range" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal">
            <div class="img-wrap" @click="enlarge">
            <img src="../assets/icon-enlarge.png" width="100%" height="100%">
            </div>
        </div>
        <div class="button-wrap">
        <div class="reupload-button" @click="chooseFile()">重新上传</div>
        <div class="goback-button" @click="goBack()">取消</div>
        <div class="clip-button" @click="generateBlob()">确认</div>
      </div>
      </div>
  </div>
</template>
<script>
import { BaseApi } from '@/common/js/BaseApi'
const prefixCls = 'fy-upload-with-clip'
export default {
  name: 'FineArtUploadWithClip',
  props: {
    action: {
      type: String,
      required: true
    },
    headers: {
      type: Object,
      default () {
        return {}
      }
    },
    data: {
      type: Object
    },
    name: {
      type: String,
      default: 'file'
    },
    type: {
      type: String,
      default: 'select'
    },
    format: {
      type: Array,
      default () {
        return []
      }
    },
    maxSize: {
      type: Number
    },
    beforeUpload: Function,
    onProgress: {
      type: Function,
      default () {
        return {}
      }
    },
    onSuccess: {
      type: Function,
      default () {
        return {}
      }
    },
    onError: {
      type: Function,
      default () {
        return {}
      }
    },
    onRemove: {
      type: Function,
      default () {
        return {}
      }
    },
    onPreview: {
      type: Function,
      default () {
        return {}
      }
    },
    onExceededSize: {
      type: Function,
      default () {
        return {}
      }
    },
    onFormatError: {
      type: Function,
      default () {
        return {}
      }
    },
    onHideclip: {
      type: Function,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      prefixCls: prefixCls,
      dragOver: false,
      fileList: [],
      tempIndex: 1,
      myCroppa: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0
    }
  },
  mounted () {
    this.$refs.componentRoot.style.width = document.documentElement.clientWidth + 'px' || document.body.clientWidth + 'px'
    this.$refs.componentRoot.style.height = document.documentElement.clientHeight + 'px' || document.body.clientHeight + 'px'
  },
  computed: {
    classes () {
      return [
        `${prefixCls}`,
        `${prefixCls}-select`
      ]
    }
  },
  methods: {
    chooseFile () {
      this.myCroppa.chooseFile()
    },
    generateBlob () {
      this.myCroppa.generateBlob((blobContent) => {
        let blob = new Blob([blobContent], {type: 'image/jpeg'})
        let file = this.blobToFile(blob, 'image.jpeg')
        this.upload(file)
        this.myCroppa.remove()
        this.onHideclip()
      })
    },
    blobToFile (blob, fileName) {
      blob.lastModifiedDate = new Date()
      blob.name = fileName
      return blob
    },
    goBack () {
      this.myCroppa.remove()
      this.onHideclip()
    },
    onNewImage () {
      // 图片绘制时触发此方法，只触发一次，设置滑动条的当前值，最小值，最大值
      this.sliderVal = this.myCroppa.scaleRatio
      this.sliderMin = this.myCroppa.scaleRatio / 2
      this.sliderMax = this.myCroppa.scaleRatio * 2
    },
    onSliderChange (evt) {
      // 滑动滚条触发此方法
      var increment = evt.target.value
      // 设置裁剪组件的缩放比例触发图片重绘
      this.myCroppa.scaleRatio = Number(increment)
    },
    shrink () {
      if (this.sliderVal >= this.sliderMin) {
        this.myCroppa.scaleRatio -= 0.06
      }
    },
    enlarge () {
      if (this.sliderVal <= this.sliderMax) {
        this.myCroppa.scaleRatio += 0.06
      }
    },
    onZoom () {
      // To prevent zooming out of range when using scrolling to zoom
      // if (this.sliderMax && this.croppa.scaleRatio >= this.sliderMax) {
      //   this.croppa.scaleRatio = this.sliderMax
      // } else if (this.sliderMin && this.croppa.scaleRatio <= this.sliderMin) {
      //   this.croppa.scaleRatio = this.sliderMin
      // }
      this.sliderVal = this.myCroppa.scaleRatio
    },
    upload (file) {
      if (!this.beforeUpload) {
        return this.post(file)
      }
      const before = this.beforeUpload(file)
      if (before && before.then) {
        before.then(processedFile => {
          if (Object.prototype.toString.call(processedFile) === '[object File]') {
            this.post(processedFile)
          } else {
            this.post(file)
          }
        }, () => {
          // this.$emit('cancel', file);
        })
      } else if (before !== false) {
        this.post(file)
      } else {
        // this.$emit('cancel', file);
      }
    },
    async post (file) {
      // check format
      if (this.format.length) {
        const _file_format = file.name.split('.').pop().toLocaleLowerCase()
        const checked = this.format.some(item => item.toLocaleLowerCase() === _file_format)
        if (!checked) {
          this.onFormatError(file, this.fileList)
          return false
        }
      }

      // check maxSize
      if (this.maxSize) {
        if (file.size > this.maxSize * 1024) {
          this.onExceededSize(file, this.fileList)
          return false
        }
      }

      this.handleStart(file)
      let formData = new FormData() // 创建form对象
      // 添加form表单中其他数据
      Object.keys(this.data).map(key => {
        formData.append(key, this.data[key])
      })
      // 通过append向form对象添加数据
      formData.append(this.name, file)
      // 添加请求头
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      BaseApi.$http.post(this.action, formData, config)
        .then(res => {
          // handle success
          if (res.data.code === 200) {
            this.handleSuccess(res.data, file)
          } else {
            this.$store.commit('ADD_MESSAGE', { msg: res.data.msg, type: 'error' })
          }
        })
        .catch((error) => {
          // handle error
          this.handleError(error, file)
        })
    },
    handleStart (file) {
      file.uid = Date.now() + this.tempIndex++
      const _file = {
        status: 'uploading',
        name: file.name,
        size: file.size,
        percentage: 0,
        uid: file.uid,
        showProgress: true
      }

      this.fileList.push(_file)
    },
    getFile (file) {
      const fileList = this.fileList
      let target
      fileList.every(item => {
        target = file.uid === item.uid ? item : null
        return !target
      })
      return target
    },
    handleProgress (e, file) {
      const _file = this.getFile(file)
      this.onProgress(e, _file, this.fileList)
      _file.percentage = e.percent || 0
    },
    handleSuccess (res, file) {
      const _file = this.getFile(file)

      if (_file) {
        _file.status = 'finished'
        _file.response = res

        this.onSuccess(res, _file, this.fileList)

        setTimeout(() => {
          _file.showProgress = false
        }, 1000)
      }
    },
    handleError (err, file) {
      const _file = this.getFile(file)
      const fileList = this.fileList

      _file.status = 'fail'

      fileList.splice(fileList.indexOf(_file), 1)

      this.onError(err, file)
    }
  }
}
</script>
<style lang="stylus" scoped>
.fy-upload-with-clip
  position: fixed
  top: 0
  left: 0
  z-index: 1024
  background-color: rgba(51, 51, 51, 0.5)
  &-select
    display: inline-block
    width: 100%
    height: 100%
  .croppa-container
    background-color: $grey-high6
    margin: 47px 0 17px 49px
    border-radius: 4px
    overflow: hidden
  .clip-form
    width: 480px
    height: 600px
    background: $white
    border-radius: 12px
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    padding: 30px
    position: relative
    .static-text-one
      font-size: 18px
      font-weight: 400
      line-height: 20px
      color: $black
    .static-text-two
      font-size: 14px
      font-weight: 400
      line-height: 26px
      color: $grey-high
      margin-top: 8px
    .button-wrap
      width: 100%
      display: flex
      flex-direction: row
      justify-content: space-between
      align-content: center
      margin-top: 52px
      .reupload-button
        font-size: 18px
        font-weight: 400
        line-height: 26px
        color: $grey-high
        height: 40px
      .goback-button
        font-size: 18px
        font-weight: 400
        line-height: 26px
        color: $grey-high
        height: 40px
        margin-left: 120px
      .clip-button
        width: 120px
        height: 40px
        line-height: 40px
        background-color: $orange
        font-size: 18px
        text-align: center
        color: $white
        border-radius: 4px
        margin-top: -6px
    .range-handle
      display: flex
      flex-direction: row
      justify-content: space-between
      align-content: center
      margin-left: 49px
      margin-right: 49px
      .img-wrap
        height: 22px
        width: 22px
        overflow: hidden
  input[type=range]
    width: 230px
    height: 6px
    outline: none
    -webkit-appearance: none
    background-color: #efefef
    border-radius: 4px
    margin-top: 8px
    &::-webkit-slider-thumb
      -webkit-appearance: none
      height: 14px
      width: 14px
      border-radius: 50%
      background: $orange
      border: none
  .close
    height: 14px
    width: 14px
    overflow: hidden
    position: absolute
    right: 30px
    top: 30px
</style>



// WEBPACK FOOTER //
// src/components/FineArtUploadWithClip.vue